import { parseMeta } from './parse_meta';

if (CASTLE_IO_APP_ID) {
  require('castle.js/dist/c');

  window.addEventListener('load', function loadCastle() {
    const userConfig = parseMeta('current-user');

    if (window._castle) {
      window._castle('setAppId', CASTLE_IO_APP_ID);
      window._castle('identify', (userConfig.user.id || userConfig.user.cookieId));
      window._castle('secure', userConfig.user.castleSignature);
    }
  });
}



// WEBPACK FOOTER //
// ./javascripts/components/castle.js